// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"F_TheComp__kpozw"};